import { useState, useCallback } from 'react';
import { startOfMonth, addMonths, subMonths } from 'date-fns';

export const useDatePicker = (initialDate = null) => {
    const [selectedDate, setSelectedDate] = useState(initialDate);
    const [currentMonth, setCurrentMonth] = useState(
        initialDate ? startOfMonth(initialDate) : startOfMonth(new Date())
    );

    const handleDateClick = useCallback((date) => {
        setSelectedDate(date);
    }, []);

    const goToNextMonth = useCallback(() => {
        setCurrentMonth(prev => addMonths(prev, 1));
    }, []);

    const goToPreviousMonth = useCallback(() => {
        setCurrentMonth(prev => subMonths(prev, 1));
    }, []);

    const isSelected = useCallback((date) => {
        if (!selectedDate) return false;
        return (
            date.getDate() === selectedDate.getDate() &&
            date.getMonth() === selectedDate.getMonth() &&
            date.getFullYear() === selectedDate.getFullYear()
        );
    }, [selectedDate]);

    return {
        selectedDate,
        currentMonth,
        handleDateClick,
        goToNextMonth,
        goToPreviousMonth,
        isSelected
    };
};
